import { PaymentStatus } from '@bonhams1793/bonhams-typescript'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import jsCookies from 'js-cookie'

import { EBonhamsCookies } from '@nx/global-types'
import { getJWTExpiryFromCookieClient } from '@nx/helpers'

import { getUserInvoices } from '@web/helpers/api'

export type UseGetUserInvoicesProps = {
  userId: number
  paymentStatus: PaymentStatus
  query?: string
  country?: string
}

export function useGetUserInvoices({
  userId,
  paymentStatus,
  query,
  country,
}: UseGetUserInvoicesProps) {
  const refreshToken = jsCookies.get(EBonhamsCookies.refresh)
  const tokenExpirationDateInSeconds = getJWTExpiryFromCookieClient(
    EBonhamsCookies.access
  )

  return useQuery({
    queryKey: ['userInvoices', { userId, paymentStatus, query, country }],
    queryFn: () => {
      const cookies = jsCookies.get()
      return getUserInvoices({
        userId,
        paymentStatus,
        query,
        country,
        accessTokenSSR: cookies.bonhams_access,
        refreshTokenSSR: cookies.bonhams_token,
      })
    },
    staleTime:
      tokenExpirationDateInSeconds > 0
        ? Math.abs(tokenExpirationDateInSeconds * 1000 - Date.now())
        : 0,
    retry: 3,
    retryDelay: 1000,
    refetchOnMount: false,
    placeholderData: keepPreviousData,
    enabled: !!refreshToken && !!userId,
  })
}
